import {atom} from "jotai";

export const loaderAtom = atom(false);
export const loaderValueAtom = atom(-1);